export const ADD_TODO = 'ADD_TODO';
export const DELETE_TODO = 'DELETE_TODO';
export const TOGGLE_TODO = 'TOGGLE_TODO';
export const ALL_TODO = 'ALL_TODO';
export const COMPLETE_TODO = 'COMPLETE_TODO';
export const INCOMPLETE_TODO = 'INCOMPLETE_TODO';
export const UPDATE_FORM = 'FORM_UPDATE';